import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import Colors from '../../resource/ResourceColors.jsx';
import {clamp} from '../../util/UtilMidi.jsx';

export const MIDI_CLOCK_HEIGHT_REM = 1.25;

const MidiClockBar = styled.div`
    position:relative;
    top: 0;
    right: 0;
    left: 0;
    height: 100%;
    background-color: ${Colors.grey(45)};
    height: ${MIDI_CLOCK_HEIGHT_REM}rem;
`;

const MidiClockBlock = styled.div`
    display: inline-block;
    position: absolute;
    top: 0;
    height: 1rem;
    border-top: 0.1rem solid ${Colors.grey(25)};
    border-bottom: 0.1rem solid ${Colors.grey(25)};
`;

const MidiClockBlockText = styled.div`
    font-family: Courier;
    color: ${Colors.grey(75)};    
    text-shadow: ${Colors.wide_text_shadow(40)};
    padding: 0.075rem 0.15rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: bold;
    font-size: 0.75rem;
`;

export class TrackMidiClockEvents extends Component {

    static propTypes = {
        zoom_factor: PropTypes.number.isRequired,
        time_division: PropTypes.number.isRequired,
        midi_clock_events: PropTypes.array.isRequired,
    }

    state = {
        zoom_factor: this.props.zoom_factor,
        bpm_events: [],
        max_bpm: 0,
        min_bpm: 1,
    };

    componentDidMount() {
        let current_bpm = 0;
        let max_bpm = 0;
        let min_bpm = 100000;
        let bpm_events = [];
        this.props.midi_clock_events.forEach(midi_clock_event => {
            const bpm = Math.floor(10 * 60000 * this.props.time_division / midi_clock_event.midi_clock) / 10;
            if (bpm !== current_bpm) {
                current_bpm = bpm;
                if (max_bpm < bpm) {
                    max_bpm = bpm;
                }
                if (min_bpm > bpm) {
                    min_bpm = bpm;
                }
                bpm_events.push({
                    bpm: bpm,
                    tick_index: midi_clock_event.tick_index,
                    timecode: midi_clock_event.timecode
                });
            }
        });
        this.setState({
            max_bpm: max_bpm,
            min_bpm: min_bpm,
            bpm_events: bpm_events
        })
    }

    set_zoom_factor(zoom_factor) {
        this.setState({zoom_factor: zoom_factor})
    }

    render() {
        const bpm_range = this.state.max_bpm - this.state.min_bpm;
        const content = this.state.bpm_events.map((bpm_event, index) => {
            const left = bpm_event.timecode / this.state.zoom_factor;
            const right =
                index < (this.state.bpm_events.length - 1) ?
                    this.state.bpm_events[index + 1].timecode / this.state.zoom_factor : left + 10;
            const position = clamp((bpm_event.bpm - this.state.min_bpm) / bpm_range, 0, 1);
            const block_style = {
                left: left + 'px',
                width: (right - left + 1) + 'px',
                backgroundColor: Colors.grey(20 + position * 30)
            };
            const bpm_text = bpm_event.bpm + ' bpm';
            const text = right - left < 80 ? '' : bpm_text;
            return <MidiClockBlock
                key={'bpm_' + index}
                style={block_style}
                title={bpm_text}>
                <MidiClockBlockText>{text}</MidiClockBlockText>
            </MidiClockBlock>
        });
        return <MidiClockBar>{content}</MidiClockBar>
    }
}

export default TrackMidiClockEvents;

